export const LAYERS = [
  { key: 'points', label: 'Titik anggota', group: 'Dasar', on: true },
  { key: 'parcels', label: 'Lahan (poligon)', group: 'Dasar', on: false },
  { key: 'labels', label: 'Label nama', group: 'Dasar', on: true },
  { key: 'esg', label: 'ESG kepatuhan', group: 'Data' },
  { key: 'density', label: 'Kepadatan anggota', group: 'Data' },
]

export const DEFAULT_LAYERS = {
  ...Object.fromEntries(LAYERS.map((l) => [l.key, Boolean(l.on)])),
  esgHotspot: false,
}

export const ESG_METRICS = [
  { value: 'onboardingScore', label: 'Kelengkapan' },
  { value: 'wageScore', label: 'Upah' },
]

export const ESG_MODES = [
  { value: 'points', label: 'Titik' },
  { value: 'hotspot', label: 'Hotspot risiko' },
]

// Overlapping heatmaps are unreadable, so turning one on switches off the other
// (ESG hotspot counts as a heatmap).
const HEATMAP_KEYS = ['density', 'esgHotspot']

export const applyLayerRules = (prev = {}, next = {}) => {
  const turnedOn = Object.keys(next).find((k) => next[k] && !prev[k])
  const out = { ...next }
  const keep = (group, key) => {
    if (!group.includes(key)) return
    group.forEach((k) => {
      if (k !== key) out[k] = false
    })
  }
  // Re-enabling ESG while its mode is hotspot brings the heatmap back too
  keep(HEATMAP_KEYS, turnedOn === 'esg' && next.esgHotspot ? 'esgHotspot' : turnedOn)
  return out
}

// Mirrors ComplianceLegend score rows (findora-dashboard).
export const ESG_LEGEND = [
  [90, '80% ke atas'],
  [70, '60% – <80%'],
  [0, 'Di bawah 60%'],
]
export const ESG_NA_COLOR = '#6b7280'

// ESG members are nested regions → suppliers → members (→ members).
export const esgScoresByUser = (data) => {
  const scores = new Map()
  const walk = (members) =>
    (members || []).forEach((m) => {
      const userId = m?.detailData?.userId
      if (userId != null) {
        scores.set(String(userId), {
          onboardingScore: m.onboardingScore,
          wageScore: m.wageScore,
        })
      }
      walk(m?.members)
    })
  ;(data?.regions || []).forEach((r) =>
    (r?.suppliers || []).forEach((s) => walk(s?.members)),
  )
  return scores
}
